import moment from "moment";
import { useTranslation } from "react-i18next";

import SettingsContentShared from "page_components/shared/settings/Content";

import { useSettings } from "context/settings";

import countries from "libs/countries.json";

const SettingsContent = () => {
  const { t } = useTranslation();

  const {
    data,
    setPersonalDataModal,
    setChangePasswordModal,
    setProfilePhotoModal,
    setLanguageModal,
  } = useSettings();

  const left_column_data = [
    {
      title: t("Account role"),
      items: [
        {
          label: t("Role"),
          value: "Administrator",
        },
      ],
    },
    {
      title: t("Personal data"),
      action: {
        label: t("Edit"),
        onclick: () => setPersonalDataModal(true),
      },
      items: [
        {
          label: t("Full name"),
          value: `${data?.first_name} ${data?.last_name}`,
        },
        {
          label: t("Email"),
          value: data?.email,
        },
        {
          label: t("Phone"),
          value: !!data?.phone?.number
            ? `${
                countries?.find((item) => item?.code === data?.phone?.code)
                  ?.dialling_code || ""
              } ${data?.phone?.number}`
            : "-",
        },
      ],
    },
    {
      title: t("Security"),
      action: {
        label: t("Change password"),
        onclick: () => setChangePasswordModal(true),
      },
      items: [
        {
          label: t("Last password change"),
          value: moment(data?.last_password_changed)?.fromNow(),
          tooltip: t(
            "We recommend using a unique password and changing it at least once a year."
          ),
        },
      ],
    },
  ];

  const right_column_data = [
    {
      title: t("Panel language"),
      items: [
        {
          type: "language",
          value: data?.language,
        },
      ],
      action: {
        label: t("Change"),
        onclick: () => setLanguageModal(true),
      },
    },
    {
      title: t("Profile photo"),
      action: {
        label: t("Change"),
        onclick: () => setProfilePhotoModal(true),
      },
      items: [
        {
          type: "avatar",
          value: data?.photo,
        },
      ],
    },
  ];

  return (
    <SettingsContentShared
      left_column_data={left_column_data}
      right_column_data={right_column_data}
    />
  );
};

export default SettingsContent;
